import React from 'react';
import classnames from 'classnames/bind';
import Reveal from '../../ui/Reveal/Reveal';
import styles from './HowItWorks.module.scss';

const cx = classnames.bind(styles);

interface IStep {
    num: string;
    name: string;
    text: string;
}

const STEPS: IStep[] = [
    {
        num: '1',
        name: 'Connect your account',
        text: 'Plug in the social account you want on autopilot. LinkedIn today, more platforms on the way.',
    },
    {
        num: '2',
        name: 'Define the mission',
        text: 'A campaign is your goal in plain words — land a role, find leads, grow an audience — plus a portrait of the people who matter to you.',
    },
    {
        num: '3',
        name: 'Let it fly',
        text: 'Shadowpilot takes the controls on a daily schedule: it reads the feed, engages the right people and steers everything toward your goal.',
    },
];

export default function HowItWorks() {
    return (
        <section className={cx('Section')} id='how-it-works'>
            <div className={cx('Inner')}>
                <Reveal>
                    <p className={cx('Eyebrow')}>How it works</p>
                    <h2 className={cx('Title')}>
                        Set it up once. <em>It flies daily.</em>
                    </h2>
                    <p className={cx('Lead')}>
                        No content calendar, no daily grind, no dashboard babysitting. You describe
                        the destination — Shadowpilot handles the flying.
                    </p>
                </Reveal>

                <div className={cx('Steps')}>
                    {STEPS.map((step, i) => (
                        <Reveal key={step.num} delay={i * 0.08} className={cx('Step')}>
                            <span className={cx('StepNum')}>{step.num}</span>
                            <h3 className={cx('StepName')}>{step.name}</h3>
                            <p className={cx('StepText')}>{step.text}</p>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
